import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InstanceLayer from "../components/InstanceLayer";


const InstanceList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Instances" />


        {/* InstanceLayer */}
        <InstanceLayer />

      </MasterLayout>
    </>
  )
};

export default InstanceList;
